<template>
    <div class="align-header">
        <ob-spinner v-if="i9Loader" loading-text="Loading..."></ob-spinner>
        <div v-else>
            <div v-if ="!emptySection && !I9Section1[0].IsSinglePaper" class="I9-container pT0">
                <div class="I9-title" >
                    <div class="text-left pull-left">
                        <h4 style="font-weight: 600;color:#143361;">FORM I-9</h4>
                            <p  v-if="I9Section1[0] != null && I9Section1[0] != ''"> 
                                <span class="auto-ext--I9" style="background-color: rgb(52, 152, 219);" v-if="I9Section1[0].UploadingExistingI9 == false"> ELECTRONIC </span> 
                                <span class="auto-ext--I9" style="background-color: rgb(241, 196, 15);" v-if="I9Section1[0].UploadingExistingI9 == true"> PAPER </span> 
                                    |
                                    <span class="I9-remote--text" v-if="I9Section1[0].AuthorizationType == 'RemoteLocation'"> REMOTE LOCATION </span> 
                                    <span class="I9-remote--text" v-if="I9Section1[0].AuthorizationType == 'EmployerLocation'"> EMPLOYER SITE </span> 
                            </p>

                    </div>
                    <div class="clearfix"></div>
                </div>


                <div v-if="EverifySection != null && EverifySection != '' && i9Details != ''">
                        <ob-vdoc-list :documentList="EverifySection" :documentDisplayName="'E-Verify'" :completeI9Details="i9Details"> </ob-vdoc-list>
                </div>

                <div v-if="I9Section1 != null && I9Section1 != '' && i9Details != ''" v-for="(data,index) in I9Section1" :key="index">
                        <ob-I9-doclist :documentList="data" :documentDisplayName="'Section - 1'" :completeI9Details="i9Details"> </ob-I9-doclist>
                </div>
            </div>

            <div v-else  style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                        Once the employer initiates and completes the Form I9.<br>
                    Section-1 of the Form I9 will be reflected here.
                    </h5>
                </div> 
            </div> 

        </div>

    </div>

</template>

<script>
import ESSMixin from './ESSMixin.js'
    export default {
        mixins: [ESSMixin],
        data() {
            return {
                emptySection : true,
                data: {},
                docName:'',
                I9Section1: '',
                i9Details: '',
                i9Loader: true,
                EverifySection: ''
            }
        },
        created(){
            this.getI9Details()
        },
        methods:{
           getI9Details(){
            
               ajax.get(`Employee/${loggedInUserObj.empId}/I9Details`, {}, res => {
                    if(res.data.State == true){
                        this.i9Loader = false
                        console.log("res", res.data)
                        console.log("EverifyDetails", res.data.EverifyDetails)
                        console.log("I9Section1Details",res.data.I9Section1Details)
                        this.I9Section1 = res.data.I9Section1Details
                        if(this.I9Section1 != null && this.I9Section1.length > 0)
                            this.emptySection = false
                        this.i9Details = res.data
                        this.EverifySection = res.data.EverifyDetails
                    }else{
                        this.i9Loader = false
                        this.ESSEnableDisable(res)
                        this.emptySection = true
                    }
               })
           } 
        }
    }
</script>

<style lang="scss" scoped>
    @import "~styles/framework/vue-utils";
    .I9-container {
        padding:15px;
    }

    .I9-title {
      // border-bottom:1px dashed #ccc;
       margin:10px 0;
       padding:10px 0;
       h3{
             font-weight:bold;
             color:#143361;
         }
    }
    
    // label for I9 ext
    .auto-ext--I9 {
        background: #4A90E2;
        padding: 2px 10px;
        border-radius: 15px;
        font-size: 10px;
        color: #fff;
        font-weight: 600;
        margin-right: 5px;
    }
    .I9-remote--text{
        font-size: 11px;
        font-weight: 600;
    }


    .pfa-body {
        padding: 15px;
        display: inline-block;
        .pfa-info_msg {
                color: $ob-brand-primary;
                font-size: 13px;
                line-height: 20px;
                margin: 0;
        }

    }     
    .align-header{
        margin-top:-10px
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/EmpFormI9.vue